import React from "react";
import DictionaryAutocomplete, { OptionType } from "../../../common/controls/DictionaryAutocomplete";
import createCustomEvent from "../../../common/utils/createCustomEvent";

export interface IProps {
	refControl: string,
	dictionaryType: string,
	parentDictionaryId: string,
	errorText: string,

	name: string,
	onSet?: (value: OptionType) => void,
}

export default function DictionaryCombobox(props: IProps) {
	const [value, setValue] = React.useState<OptionType>(null);
	const [parentDictionaryId, setParentDictionaryId] = React.useState<string>(null);

	const idControlRef = React.useRef<HTMLInputElement>();
	const nameControlRef = React.useRef<HTMLInputElement>();
	const parentControlIdRef = React.useRef<HTMLInputElement>();

	React.useEffect(() => {
		idControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "_id']");
		nameControlRef.current = document.querySelector("input[data-ref='" + props.refControl + "_name']");

		if (!idControlRef.current) {
			console.warn("Not found data-ref='" + props.refControl +"_id'.");
		}
		if (!nameControlRef.current) {
			console.warn("Not found data-ref='" + props.refControl + "_name'.");
		}

		if (props.parentDictionaryId) {
			parentControlIdRef.current = document.getElementById(props.parentDictionaryId) as HTMLInputElement;
			if (parentControlIdRef.current) {
				setParentDictionaryId(parentControlIdRef.current.value);

				parentControlIdRef.current.addEventListener("change", (e) => {
					setParentDictionaryId((e as any).target.value);
				});
			}
			else {
				console.warn("No element found with id \"" + props.parentDictionaryId + "\".");
			}
		}

		if (idControlRef.current && idControlRef.current.value && idControlRef.current.value != "00000000-0000-0000-0000-000000000000") {
			let newV = {
				value: idControlRef.current.value,
				label: nameControlRef.current.value,
			}
			setValue(newV);
			if (props.onSet)
				props.onSet(newV);
		}
	}, []);

	return <DictionaryAutocomplete
		value={value}
		onChange={(v) => {
			setValue(v);
			idControlRef.current.value = v?.value ?? "00000000-0000-0000-0000-000000000000";
			nameControlRef.current.value = v?.label ?? "";

			let event = createCustomEvent("change");
			idControlRef.current.dispatchEvent(event);

			if (props.onSet)
				props.onSet(v);
		}}

		dictionaryName={props.dictionaryType}
		parentDictionaryId={parentDictionaryId}

		className="qd-combocoxs-control"
		error={!!props.errorText}
		helperText={props.errorText}
	/>
}
